import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { InjectionToken, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BrandService } from '../services/brand.service';

export const BRAND_CD = new InjectionToken<string>('brandCd');
export const BRAND_ID = new InjectionToken<string>('brandId');
export const BRAND_IGNORE_PATH_LIST = new InjectionToken<string[]>(
  'brandIgnorePathList',
);

/**
 * 브랜드 인터셉터 Fn
 */
export const brandInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const brandService = inject(BrandService);
  const ignorePathList = inject(BRAND_IGNORE_PATH_LIST);

  if (
    req.url.startsWith(environment.apiServerUrl) &&
    !req.url.includes('/pms/') &&
    !ignorePathList.some((path) => req.url.includes(path))
  ) {
    let { headers } = req;
    const { params } = req;

    if (brandService.brand?.id != null) {
      headers = req.headers.set('Brand-Id', `${brandService.brand.id}`);
    }

    return next(
      req.clone({
        // API 서버 CorsFilter에서 Access-Control-Allow-Headers에 Brand-Id 추가 필요
        headers,
        params,
      }),
    );
  }

  return next(req);
};
